<script>
export default {
    name: 'LoadIndicator',
};
</script>

<template>
    <div class="load-indicator">
        Laden…
    </div>
</template>

<style lang="scss" scoped>
.load-indicator {
    font-size: 1.6rem;
}
</style>
